import { Component, ChangeDetectorRef } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import {
  TranslateService,
  TranslatePipe,
  TranslateDirective,
  LangChangeEvent
} from "@ngx-translate/core";

import { TaxesService } from '../../../../services/taxes.service';
import { RateModelDto } from '../../../../models/ratemodeldto';
import { ServicesService } from '../../../../services/services.service';
import { ServiceDto } from '../../../../models/servicedto';
import { Subscription } from 'rxjs';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { ErrorModalComponent } from '../../../../components/error-modal/error-modal.component';
import { SharedService } from '../../../../services/shared.service';
import { RateModelRequest } from '../../../../models/rateModelRequest';
import { RateModelResponse } from '../../../../models/rateModelResponse';
import { AlertComponentComponent } from "../../../../components/alert/alert-component.component";
import { AcademicTaxesService } from '../../../../services/academicTaxes.service';
import { AcademicFeeDto } from '../../../../models/academicfeedto';
import { LearningResourceFeeService } from '../../../../services/learningresourcefee.service';
import { LearningResourceFeeDto } from '../../../../models/learningresourcefeedto';
import { OwnAdministrativeFeeService } from '../../../../services/ownadministrativefee.service';
import { OwnAdministrativeFeeDto } from '../../../../models/ownadministrativefeedto';
import { DiscountService } from '../../../../services/discountService.service';
import { GeneralDiscountCatalogDto } from '../../../../models/discountGeneralCatalog/GeneralDiscountCatalogDto.model';
import { DiscountRateModelCatalogDto, DiscountRateModelCatalogRequest, DiscountRateModelCatalogResponse } from '../../../../models/discountGeneralCatalog/DiscountRateModelCatalog.model';
import { DiscountModelRateControlTypeDto, DiscountModelRateControlTypeRequest, DiscountModelRateControlTypeResponse } from '../../../../models/discountGeneralCatalog/DiscountModelRateControlTypeDto.model';
import { DiscountControlTypeDto } from '../../../../models/discountGeneralCatalog/DiscountControlTypesDto.model';
@Component({
  selector: 'app-model',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, FormsModule, CommonModule, ReactiveFormsModule, TranslatePipe, TranslateDirective, PaginatorComponent, ErrorModalComponent, AlertComponentComponent],
  templateUrl: './model.component.html',
  styleUrl: './model.component.css'
})
export class ModelComponent {
  links: any[] = [];
  subLinks: any[] = [];

  RateModelDto: RateModelDto = new RateModelDto(); // Instancia de RateModelDto
  listModels: RateModelDto[] = []; // Lista de elementos
  listServices: ServiceDto[] = []; // Lista de servicios
  listDiscountControlType: DiscountControlTypeDto[] = [];

  selectedRowId: number | null = null; // Variable para almacenar el ID de la fila seleccionada
  selectedRowDiscountId: number | null = null; // Variable para almacenar el ID de la fila seleccionada
  selectedRowDiscountTypeId: number | null = null; // Variable para almacenar el ID de la fila seleccionada
  selectedValidationRateModelWithControlId: number | null = null; // Variable para almacenar el ID de la fila seleccionada

  isModify: boolean = false; // Variable para determinar si se está modificando un elemento
  openCreate: boolean = false; // Variable para determinar si se está creando un nuevo elemento
  currentLanguage: string = 'es'; // Idioma actual
  selectedTypology: string = ''; // Tipología seleccionada
  modifTranslates: boolean = false; // Variable para determinar si se han modificado las traducciones

  isError: boolean = false; // Título del modal de error
  isErrorDiscount: boolean = false; // Título del modal de error
  isErrorDiscountType: boolean = false; // Título del modal de error

  isCreate: boolean = false; // Mensaje del modal de error
  isCreateDiscount: boolean = false; // Mensaje del modal de error
  isCreatedDiscount: boolean = false; // Mensaje del modal de error
  isCreateDiscountType: boolean = false; // Mensaje del modal de error
  isCreatedDiscountType: boolean = false; // Mensaje del modal de error

  selectAll: boolean = false;
  errorMessage: string = ''
  taxesAcademiques: AcademicFeeDto[] = []
  learningresource: LearningResourceFeeDto[] = []
  OwnAdministrativeFee: OwnAdministrativeFeeDto[] = [];
  listGeneralDiscountCatalogDto: GeneralDiscountCatalogDto[] = [];

  modelRequest: RateModelRequest = new RateModelRequest();
  modelResponse: RateModelResponse = new RateModelResponse();

  discountRateModelRequest: DiscountRateModelCatalogRequest = new DiscountRateModelCatalogRequest();
  discountRateModelResponse: DiscountRateModelCatalogResponse = new DiscountRateModelCatalogResponse();

  discountModelRateControlTypeRequest: DiscountModelRateControlTypeRequest = new DiscountModelRateControlTypeRequest();
  discountModelRateControlTypeResponse: DiscountModelRateControlTypeResponse = new DiscountModelRateControlTypeResponse();

  private langChangeSubscription!: Subscription;
  constructor(private routelinks: RoutelinksService, private cdr: ChangeDetectorRef, private taxesService: TaxesService,
    private translateService: TranslateService, private servicesService: ServicesService, private sharedService: SharedService, private academictaxesservice: AcademicTaxesService, private learningResourceFeeService: LearningResourceFeeService, private ownadministrativefeeService: OwnAdministrativeFeeService, private discountService: DiscountService
  ) {
    this.links = this.routelinks.linksTaxes; // Inicializa la propiedad en el constructor
    this.currentLanguage = this.translateService.currentLang || 'es'; // Establece el idioma actual
  }

  //#region filtrado
  filterParams = new FormGroup({
    taxType: new FormControl(''), // Control para el select "Tipo de tasa"
    codeModel: new FormControl(''), // Control para el input "Código"
    status: new FormControl(''), // Control para el input "Estado"
    name: new FormControl('')
  });

  formComponent = new FormGroup({
    codeRateModel: new FormControl(''), // Input Código
    active: new FormControl(''), // Select Estado
    serviceTypeId: new FormControl('', Validators.required), // Select Tipo de servicio
    shortCastellano: new FormControl('', Validators.required), // Input Nombre (Castellano)
    shortCatala: new FormControl('', Validators.required), // Input Nombre (Català)
    shortEnglish: new FormControl('', Validators.required), // Input Nombre (English)
    longCastellano: new FormControl('', Validators.required), // Input Descripción (Castellano)
    longCatala: new FormControl('', Validators.required), // Input Descripció (Català)
    longEnglish: new FormControl('', Validators.required), // Input Description (English)
    typology: new FormControl('P'),
    academicFees: new FormControl(false), // Checkbox Tasas académicas
    learningResourcesRates: new FormControl(false), // Checkbox Tasas recursos aprendizaje
    shippingRates: new FormControl(false), // Checkbox Tasas de envío
    administrativeFees: new FormControl(false), // Checkbox Tasas administrativas
    surcharges: new FormControl(false), // Checkbox Recargas
  });

  formDiscount = new FormGroup({
    generalDiscountCatalogId: new FormControl(0),
    rateModelId: new FormControl(0, Validators.required),
    cumulativeIndicator: new FormControl(false),
    managerIndicator: new FormControl(false),
    studentIndicator: new FormControl(false),
    usesControlType: new FormControl(false),
  });

  formDiscountTypes = new FormGroup({
    generalDiscountCatalogId: new FormControl(0),
    rateModelId: new FormControl(0),
    discountControlTypeId: new FormControl(0),
    controlType: new FormControl('NI'),
    alphanumericValue: new FormControl(0),
    numericValue: new FormControl(0),
    decimalValue: new FormControl(0),
    dateStart: new FormControl(''),
    dateEnd: new FormControl('')
  });

  ngOnInit(): void {
    this.links = this.routelinks.linksTaxes; // Inicializa la propiedad en ngOnInit
    this.subLinks = this.routelinks.subLinksTaxes; // Inicializa la propiedad en ngOnInit

    this.onTaxTypeChange(true) // Llama al método para obtener la lista de tasas propias
    this.getListServices(); // Llama al método para obtener la lista de servicios
    this.loadDiscountControlTypes()

    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang; // Actualizar el idioma actual
      this.cdr.detectChanges();
      this.getListServices(); // Llama al método para obtener la lista de servicios
      this.onFilterChange();
    });

    // Servicio encargado de escuchar cuando se cambia de página
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      console.log(localStorage.getItem('currentPage'))
      if (localStorage.getItem('currentPage') === 'rateModelCatalog') {
        this.modelResponse.pageDto.currentPage = page;
        this.onTaxTypeChange(false);
      } else if (localStorage.getItem('currentPage') === 'discountRateModelCatalog') {
        this.discountRateModelResponse.pageDto.currentPage = page;
        this.loadDiscountsRateModel()
      } else if (localStorage.getItem('currentPage') === 'discountModelRateControlType') {
        this.discountModelRateControlTypeResponse.pageDto.currentPage = page;
      }
    });

    // Servicio encargado de escuchar cuando se cambia de resultados por pagina
    this.sharedService.sizePageEventEmitter.subscribe((results: number) => {
      if (localStorage.getItem('currentPage') === 'rateModelCatalog') {
        this.modelRequest.pageRequest.sizePage = results;
        this.onTaxTypeChange(true);
      } else if (localStorage.getItem('currentPage') === 'discountRateModelCatalog') {
        this.discountRateModelRequest.pageRequest.sizePage = results;
        this.loadDiscountsRateModel();
      }
    });

    this.filterParams.get('taxType')?.valueChanges.subscribe((value) => {
      this.selectedTypology = value || ''; // Guarda el valor en una propiedad si es necesario
      this.modelRequest.pageRequest.page = 1; // Reinicia la página a 0 al cambiar el tipo de tasa
      this.selectedRowId = this.selectedRowDiscountId = this.selectedRowDiscountTypeId = null; // Deselecciona cualquier fila seleccionada
      this.discountRateModelResponse.discountRateModelCatalogDto = []
      this.formComponent.get('typology')?.patchValue(value)
      this.filterParams.get('name')?.patchValue('')
      this.filterParams.get('codeModel')?.patchValue('')
      this.filterParams.get('status')?.patchValue('')
      this.onTaxTypeChange(true);
    });

  }
  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  loadDiscounts() {
    this.discountModelRateControlTypeRequest.pageRequest.sizePage = 100;
    this.discountService.getListGeneralDiscountCatalog(this.discountRateModelRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.listGeneralDiscountCatalogDto = response.listGeneralDiscountCatalog.map((rt: any) => {
            return {
              ...rt,
              generalDiscountCatalogTraductionDto: rt.generalDiscountCatalogTraductionDto.filter((t: any) => t.languageDto.code.includes(this.translateService.currentLang || 'es')),
            };
          });
        }
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  loadDiscountControlTypes() {
    this.discountService.getListDiscountControlType(this.discountRateModelRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.listDiscountControlType = response.listDiscountControlType;
        }
      }, error: error => {
      }
    });
  }

  loadDiscountsRateModel() {
    this.discountRateModelRequest.pageRequest.sizePage = 100;
    this.discountRateModelRequest.pageRequest.page = this.discountRateModelResponse.pageDto.currentPage;
    console.log('Selected Row ID:', this.selectedRowId);
    this.discountService.getListDiscountRateModelCatalog(this.discountRateModelRequest.pageRequest, this.selectedRowId).subscribe({
      next: response => {
        if (response != null) {
          this.discountRateModelResponse.discountRateModelCatalogDto = response.listDiscountRateModelCatalog.filter((discount: { rateModelDto: { idRateModel: number | null; }; }) => { return discount.rateModelDto.idRateModel == this.selectedRowId })
          this.discountRateModelResponse.discountRateModelCatalogDto = sortByDiscountCode(this.discountRateModelResponse.discountRateModelCatalogDto)
          if (response.pageDto !== undefined) {
            this.discountRateModelResponse.pageDto = response.pageDto;
          }
          this.loadDiscounts()

        }
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  loadDiscountsRateModelTypes() {
    this.discountService.getListDiscountRateModelControlTypeCatalog(this.discountModelRateControlTypeRequest.pageRequest, this.selectedRowId, this.selectedRowDiscountId).subscribe({
      next: response => {
        if (response != null) {
          this.discountModelRateControlTypeResponse.discountModelRateControlTypeDto = response.listDisctValidRmWithCtypeDto
          this.discountModelRateControlTypeResponse.discountModelRateControlTypeDto.length > 0 ? this.controlUseType(true) : this.controlUseType(false)

        }
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }
  controlUseType(control: boolean) {
    if (control) {
      this.formDiscount.get('usesControlType')?.patchValue(true)
      this.formDiscount.get('usesControlType')?.disable()
    } else {
      this.formDiscount.get('usesControlType')?.patchValue(false)
      this.formDiscount.get('usesControlType')?.enable()
    }
  }

  loadDiscountsValidations() {
    this.discountService.getListDiscountRateModelValidations(this.discountModelRateControlTypeRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          console.log(response)
        }
      }, error: (error: any) => {
      }
    });
  }

  getServiceDescription(serviceDto?: any): string {
    if (!serviceDto[0] || serviceDto[0].length === 0) {
      return 'N/A'; // Retorna 'N/A' si serviceDto[0] o languageDto no están definidos o están vacíos
    }
    return serviceDto[0].shortDescription; // Retorna 'N/A' si el índice no es válido
  }

  getDiscountDescription(id?: any): string {
    let descr;
    let discount = this.listGeneralDiscountCatalogDto.filter(list => { return list.idGeneralDiscountCatalog == id })
    if (discount.length === 0) {
      return '';
    }
    discount[0].generalDiscountCatalogTraductionDto ? descr = discount[0].generalDiscountCatalogTraductionDto[0].discountDescription : descr = discount[0]?.discountCode;
    return descr || ''
  }

  onTaxTypeChange(init: boolean) {
    if (!init) {
      this.modelRequest.pageRequest.page = this.modelResponse.pageDto.currentPage;
    }
    this.isError = false
    this.taxesService.getListTaxesByFilters(this.modelRequest.pageRequest,
      this.filterParams.controls.taxType.value || '', this.filterParams).subscribe({
        next: response => {
          if (response != null) {
            this.modelResponse.listRateModelDto = response.listRateModel.map((rt: any) => {
              return {
                ...rt,
                rateModelTraductionDto: rt.rateModelTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
                serviceDto: rt.serviceDto.serviceTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage))
              };
            });
            if (response.pageDto !== undefined) {
              this.modelResponse.pageDto = response.pageDto;
            }
          }
        }, error: error => {
          this.listModels = []; // Asigna una lista vacía en caso de error
        }
      });
  }


  toggleRow(row: any): void {
    if (this.selectedRowId === row.idRateModel) {
      window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
      setTimeout(() => {
        this.selectedRowId = null; // Deselecciona si ya estaba seleccionada
        this.selectedRowDiscountId = null
        this.discountRateModelResponse.discountRateModelCatalogDto = []
        this.discountModelRateControlTypeResponse.discountModelRateControlTypeDto = []
        this.openCreate = false; // Quita el modo de creación
        this.isModify = false; //Quita modo de modificación
      }, 350);
      this.formComponent.reset();

    } else {
      this.selectedRowId = row.idRateModel; // Selecciona la nueva fila
      this.isModify = true; // Cambia a modo de modificación
      this.openCreate = false; // Quita el modo de creación
      this.taxesService.getRateModelByCode(row.codeRateModel).subscribe({
        next: (response) => {
          console.log('Modelo seleccionado:', response);
          this.RateModelDto = response; // Asigna la respuesta a RateModelDto
          // Verifica si rateModelTraductionDto está definido y tiene suficientes elementos
          const catalanIndex = this.RateModelDto?.rateModelTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === "ca"
          ) ?? -1;

          const spanishIndex = this.RateModelDto?.rateModelTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === "es"
          ) ?? -1;

          const englishIndex = this.RateModelDto?.rateModelTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === "en"
          ) ?? -1;

          // Realiza el patchValue para actualizar el formulario
          this.formComponent.patchValue({
            codeRateModel: this.RateModelDto?.codeRateModel || '',
            active: this.RateModelDto?.active || '',
            serviceTypeId: this.RateModelDto?.serviceDto?.idService?.toString() || '',
            shortCastellano: spanishIndex >= 0 ? this.RateModelDto?.rateModelTraductionDto?.[spanishIndex]?.shortDescription || '' : '',
            shortCatala: catalanIndex >= 0 ? this.RateModelDto?.rateModelTraductionDto?.[catalanIndex]?.shortDescription || '' : '',
            shortEnglish: englishIndex >= 0 ? this.RateModelDto?.rateModelTraductionDto?.[englishIndex]?.shortDescription || '' : '',
            longCastellano: spanishIndex >= 0 ? this.RateModelDto?.rateModelTraductionDto?.[spanishIndex]?.longDescription || '' : '',
            longCatala: catalanIndex >= 0 ? this.RateModelDto?.rateModelTraductionDto?.[catalanIndex]?.longDescription || '' : '',
            longEnglish: englishIndex >= 0 ? this.RateModelDto?.rateModelTraductionDto?.[englishIndex]?.longDescription || '' : '',
            academicFees: this.RateModelDto?.academicFees || false,
            learningResourcesRates: this.RateModelDto?.learningResourcesRates || false,
            shippingRates: this.RateModelDto?.shippingRates || false,
            administrativeFees: this.RateModelDto?.administrativeFees || false,
            surcharges: this.RateModelDto?.surcharges || false,
          });
          if (this.formComponent.get('codeRateModel')?.value?.includes('CLONE')) {
            this.formComponent.get('codeRateModel')?.enable();
          } else {
            this.formComponent.get('codeRateModel')?.disable();
          }
          this.formDiscount.reset()
          this.isCreateDiscount = false;
          this.selectedRowDiscountId = null;
          this.loadTaxesAcademics()
          this.loadLearningResourcesFees()
          this.loadOwnAdministrativeFees()
          this.loadDiscountsRateModel()
          this.formComponent.get('surcharges')?.disable();
          this.formComponent.get('shippingRates')?.disable();

        }
      });

      this.cdr.detectChanges();
      window.scrollTo(0, 600);
      //Rellenar formComponent con el obj de la fila seleccionada
    }
  }

  toggleRowDiscount(row: any): void {
    console.log(row)

    if (this.selectedRowDiscountId === row.discountRateModelCatalogPkDto?.generalDiscountCatalogId) {
      window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
      setTimeout(() => {
        this.isCreateDiscount = false
        this.selectedRowDiscountId = null; // Deselecciona si ya estaba seleccionada
        this.discountModelRateControlTypeResponse.discountModelRateControlTypeDto = []
      }, 350);
      this.formDiscount.reset();
    } else {
      this.isCreateDiscount = false
      this.selectedRowDiscountId = row.discountRateModelCatalogPkDto?.generalDiscountCatalogId; // Selecciona la nueva fila
      this.formDiscount.patchValue({
        generalDiscountCatalogId: row.discountRateModelCatalogPkDto?.generalDiscountCatalogId,
        rateModelId: row.discountRateModelCatalogPkDto?.rateModelId,
        studentIndicator: row.studentIndicator == 'S' ? true : false,
        cumulativeIndicator: row.cumulativeIndicator == 'S' ? true : false,
        managerIndicator: row.managerIndicator == 'S' ? true : false,
        usesControlType: row.usesControlType == 'S' ? true : false
      }
      )
      this.formDiscount.enable()
      this.formDiscount.get('generalDiscountCatalogId')?.disable()
      this.loadDiscountsRateModelTypes()
      //this.loadDiscountsValidations()
    }
  }

  toggleRowDiscountType(row: any): void {

    if (this.selectedRowDiscountTypeId === row.discountModelRateControlTypePkDto?.discountControlTypeId) {
      setTimeout(() => {
        this.isCreateDiscountType = false
        this.selectedRowDiscountTypeId = null; // Deselecciona si ya estaba seleccionada
      }, 350);
      this.formDiscountTypes.reset();
    } else {
      console.log(row)
      this.isCreateDiscountType = false
      this.selectedRowDiscountTypeId = row.idDiscountValidationRateModelWithControl; // Selecciona la nueva fila
      this.formDiscountTypes.patchValue({
        generalDiscountCatalogId: row.generalDiscountCatalogId,
        discountControlTypeId: row.discountControlTypeId,
        controlType: row.discountControlTypeId,
        dateStart: row.valueStartDate ? row.valueStartDate.split('T')[0] : '',
        dateEnd: row.valueEndDate ? row.valueEndDate.split('T')[0] : '',
        numericValue: row.numericValue,
        rateModelId: row.rateModelId,
      }
      )
      this.formDiscountTypes.disable()
      console.log(this.formDiscountTypes.value)
    }
  }

  createDiscount() {
    this.selectedRowDiscountId = null;
    this.isCreateDiscount = true;
    this.formDiscount.reset()
    this.formDiscount.enable()
    this.formDiscount.get('usesControlType')?.disable()
  }

  createDiscountType() {
    this.selectedRowDiscountTypeId = null;
    this.isCreateDiscountType = true;
    this.formDiscountTypes.reset()
    this.formDiscountTypes.enable()
  }

  saveDiscount() {
    if (!this.selectedRowDiscountId) {
      this.discountService.insertDiscountRateModelCatalog(this.buildDiscountDTO()).subscribe({
        next: (response) => {
          this.isCreatedDiscount = true
          this.isErrorDiscount = false
          this.errorMessage = "S'ha creat correctament"
          this.selectedRowDiscountId = null
          this.isCreateDiscount = false
          this.loadDiscountsRateModel()


        },
        error: (error) => {
          this.isCreatedDiscount = false
          this.isErrorDiscount = true
          this.errorMessage = error.error.message
        }
      });
    } else {
      this.discountService.updateDiscountRateModelCatalog(this.buildDiscountDTO()).subscribe({
        next: (response) => {
          this.isErrorDiscount = false
          this.isCreatedDiscount = true
          this.errorMessage = "S'ha editat correctament"
          this.loadDiscountsRateModel()

        },
        error: (error) => {
          this.isErrorDiscount = true
          this.isCreatedDiscount = false
          this.errorMessage = error.error.message
        }
      });
    }
  }

  saveDiscountType() {
    if (this.formDiscountTypes.invalid) {
      console.log('Formulario inválido', this.formDiscountTypes);
      return;
    }
    if (!this.selectedRowDiscountTypeId) {
      this.discountService.insertDiscountRateModelControlTypeCatalog(this.buildDiscountTypeDTO()).subscribe({
        next: (response) => {
          this.isCreatedDiscountType = true
          this.isErrorDiscountType = false
          this.errorMessage = "S'ha creat correctament"
          this.loadDiscountsRateModelTypes()
          this.selectedRowDiscountTypeId = null
          this.isCreateDiscountType = false

        },
        error: (error) => {
          this.isCreatedDiscountType = false
          this.isErrorDiscountType = true
          this.errorMessage = error.error.message
        }
      });
    } else {
      this.discountService.updateDiscountRateModelControlTypeCatalog(this.buildDiscountTypeDTO()).subscribe({
        next: (response) => {
          this.isCreatedDiscountType = true
          this.isErrorDiscountType = false
          this.errorMessage = "S'ha editat correctament"
          this.loadDiscountsRateModelTypes()
        },
        error: (error) => {
          this.isCreatedDiscountType = false
          this.isErrorDiscountType = true
          this.errorMessage = error.error.message
        }
      });
    }
  }

  buildDiscountDTO(): DiscountRateModelCatalogDto {
    let discount: DiscountRateModelCatalogDto = new DiscountRateModelCatalogDto()
    discount.discountRateModelCatalogPkDto = { generalDiscountCatalogId: this.formDiscount.get('generalDiscountCatalogId')?.value || 0, rateModelId: this.selectedRowId || 0 }
    discount.rateModelDto = { idRateModel: this.selectedRowId || 0 }
    discount.generalDiscountCatalogDto = { idGeneralDiscountCatalog: this.formDiscount.get('generalDiscountCatalogId')?.value || 0 }
    discount.managerIndicator = this.formDiscount.get('managerIndicator')?.value ? 'S' : 'N';
    discount.studentIndicator = this.formDiscount.get('studentIndicator')?.value ? 'S' : 'N';
    discount.usesControlType = this.formDiscount.get('usesControlType')?.value ? 'S' : 'N';
    discount.cumulativeIndicator = this.formDiscount.get('cumulativeIndicator')?.value ? 'S' : 'N';
    return discount
  }

  buildDiscountTypeDTO(): DiscountModelRateControlTypeDto {
    let discount: any = new DiscountModelRateControlTypeDto()
    console.log(this.formDiscountTypes.value)
    discount.discountModelRateControlTypePkDto = { generalDiscountCatalogId: this.selectedRowDiscountId || undefined, rateModelId: this.selectedRowId || 0, discountControlTypeId: this.formDiscountTypes.get('discountControlTypeId')?.value || undefined }
    discount.rateModelDto = { idRateModel: this.selectedRowId || 0 }
    discount.generalDiscountCatalogDto = { idGeneralDiscountCatalog: this.selectedRowDiscountId || undefined }
    discount.discountValidationRateModelWithControlTypeDto = { numericValue: this.formDiscountTypes.get('numericValue')?.value || undefined, valueStartDate: this.formDiscountTypes.get('dateStart')?.value || undefined, valueEndDate: this.formDiscountTypes.get('dateEnd')?.value || undefined }
    return discount
  }

  // Método para filtrar los datos de la tabla
  onFilterChange(): void { // Ese page hay que cambiarlo
    this.taxesService.getListTaxesByFilters(this.modelRequest.pageRequest,
      this.selectedTypology, this.filterParams).subscribe({
        next: response => {
          if (response != null) {
            // Asigna la lista de modelos a la propiedad listModels para mostrarlos en la tabla
            this.modelResponse.listRateModelDto = response.listRateModel.filter((rt: any) => {
              const statusFilter = this.filterParams.controls.status.value;
              return !statusFilter || rt.active?.toString() === statusFilter;
            })
              .map((rt: any) => {
                return {
                  ...rt,
                  rateModelTraductionDto: rt.rateModelTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
                  serviceDto: rt.serviceDto.serviceTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage))
                };
              });
            if (response.pageDto !== undefined) {
              this.modelResponse.pageDto = response.pageDto;
            }
          }
        }, error: error => {
          this.listModels = []; // Asigna una lista vacía en caso de error
        }
      });
  }
  //#endregion

  genNewModel(): void {
    // Lógica para generar un nuevo modelo
    this.openCreate = true; // Cambia a modo de creación
    this.isModify = false; // Cambia a modo de creación
    this.formComponent.reset(); // Reinicia el formulario
    this.formComponent.enable(); // Reinicia el formulario
    this.selectedRowDiscountId = this.selectedRowDiscountTypeId = this.selectedRowId = null
    this.discountRateModelResponse.discountRateModelCatalogDto = []
    this.formComponent.get('surcharges')?.disable()
    this.formComponent.get('shippingRates')?.disable()
    this.RateModelDto = new RateModelDto(); // Reinicia la instancia de RateModelDto
    this.cdr.detectChanges();
    window.scrollTo(0, 600);
  }

  onNewModelClick(): void {
    if (this.selectedTypology === '') {
      console.log('Mostrando modal de error'); // Agrega un log para verificar
      this.isError = true
      this.errorMessage = this.translateService.instant('error.message.typology');
    } else {
      this.isError = false
      this.genNewModel(); // Llama al método para crear un nuevo modelo
    }
  }

  // Método para manejar el envío del formulario
  onSubmit(): void {
    if (this.formComponent.valid) {
      this.bindFormToObj();
      if (this.checkForNullTranslations()) {
        return; // Detiene la ejecución si hay traducciones nulas
      }
      if (this.isModify) {
        if (this.taxesAcademiques.length > 0 && this.formComponent.get('active')?.value == 'S' && !this.formComponent.get('academicFees')?.value) {
          this.isError = true;
          this.errorMessage = 'errorTaxesAcademiques'
          return
        }
        if (this.learningresource.length > 0 && this.formComponent.get('active')?.value == 'S' && !this.formComponent.get('learningResourcesRates')?.value) {
          this.isError = true;
          this.errorMessage = 'errorLearningResourcesRates'
          return
        }

        if (this.OwnAdministrativeFee.length > 0 && this.formComponent.get('active')?.value == 'S' && !this.formComponent.get('administrativeFees')?.value) {
          this.isError = true;
          this.errorMessage = 'errorAdministrativeFees'
          return
        }
        this.modifTranslates = true; // Reinicia la variable de traducciones modificadas
        this.taxesService.updateRateModel(this.modifTranslates, this.RateModelDto).subscribe({
          next: (response) => {
            console.log('Modelo actualizado:', response);
            this.isCreate = true
            this.isError = false
            this.errorMessage = "S'ha editat correctament"
            this.openCreate = false; // Quita el modo de creación
            //this.isModify = false; //Quita modo de modificación
            this.onTaxTypeChange(true);
            if (this.formComponent.get('codeRateModel')?.value?.includes('CLONE')) {
              this.formComponent.get('codeRateModel')?.enable();
            } else {
              this.formComponent.get('codeRateModel')?.disable();
            }
            // Aquí puedes manejar la respuesta después de actualizar el modelo
          },
          error: (error) => {
            this.isError = true
            this.errorMessage = error.error.message
            console.log('Error al actualizar el modelo:', error.error.message);
          }
        });
        // Aquí puedes realizar la llamada a la API para actualizar el modelo
        console.log('Objeto a actualizar:', this.RateModelDto);
      } else {
        console.log('Creando un nuevo modelo...');
        this.taxesService.insertRateModel(this.RateModelDto).subscribe({
          next: (response) => {
            console.log('Modelo creado:', response);
            // Aquí puedes manejar la respuesta después de crear el modelo
            // Recarga la pagina
            this.isCreate = true
            this.isError = false
            this.openCreate = false; // Quita el modo de creación
            this.errorMessage = "S'ha creat correctament"
            this.onTaxTypeChange(true);
          },
          error: (error) => {
            this.isError = true
            this.errorMessage = error.error.message
            console.log('Error al actualizar el modelo:', error.error.message);
          }
        });
        console.log(this.RateModelDto);
        //Llamada crear modelo
      }
    } else {
      this.isError = true
      this.errorMessage = 'obligatorios'
    }
  }

  // Método auxiliar para verificar traducciones nulas
  private checkForNullTranslations(): boolean {
    const hasNullTranslations = this.RateModelDto.rateModelTraductionDto?.some(translation =>
      !translation.shortDescription || !translation.longDescription
    );
    if (hasNullTranslations) {
      console.log('Mostrando error por traducciones nulas');
      this.isError = true
      this.errorMessage = this.translateService.instant('error.message.translations');
      return true; // Indica que hay traducciones nulas
    }
    return false; // No hay traducciones nulas
  }

  // Método de instancia para actualizar el objeto desde un FormGroup o crear uno nuevo
  bindFormToObj() {

    if (this.isModify) {
      this.RateModelDto.idRateModel = Number(this.selectedRowId); // Asigna el ID del modelo seleccionado
    }
    this.RateModelDto.codeRateModel = this.formComponent.get('codeRateModel')?.value ?? undefined;
    if (!this.RateModelDto.serviceDto) {
      this.RateModelDto.serviceDto = new ServiceDto(); // Inicializa serviceDto si es undefined
    }
    // Encuentra el serviceDto correspondiente en listServices
    const serviceTypeId = Number(this.formComponent.get('serviceTypeId')?.value);
    this.RateModelDto.serviceDto = this.listServices.find(service => service.idService === serviceTypeId) || undefined;
    // Asignar checkboxes a la propiedad correspondiente
    this.RateModelDto.shippingRates = this.formComponent.get('shippingRates')?.value ?? false;
    this.RateModelDto.administrativeFees = this.formComponent.get('administrativeFees')?.value ?? false;
    this.RateModelDto.surcharges = this.formComponent.get('surcharges')?.value ?? false;
    this.RateModelDto.active = this.formComponent.get('active')?.value ?? undefined;
    this.RateModelDto.learningResourcesRates = this.formComponent.get('learningResourcesRates')?.value ?? false;
    this.RateModelDto.academicFees = this.formComponent.get('academicFees')?.value ?? false;
    this.RateModelDto.typology = this.filterParams.get('taxType')?.value ?? 'P';

    if (!this.RateModelDto.rateModelTraductionDto) {
      this.RateModelDto.rateModelTraductionDto = []; // Inicializa rateModelTraductionDto si es undefined
    }
    if (this.RateModelDto.rateModelTraductionDto) {

      // Verifica si rateModelTraductionDto tiene suficientes elementos, si no, los inicializa
      if (!this.RateModelDto.rateModelTraductionDto || this.RateModelDto.rateModelTraductionDto.length === 0) {
        this.RateModelDto.rateModelTraductionDto = [
          { languageDto: { idLanguage: 1 }, shortDescription: undefined, longDescription: undefined },
          { languageDto: { idLanguage: 2 }, shortDescription: undefined, longDescription: undefined },
          { languageDto: { idLanguage: 3 }, shortDescription: undefined, longDescription: undefined }
        ];
      }
      this.RateModelDto.rateModelTraductionDto.forEach((translation) => {
        if (translation.languageDto?.code === "es" || translation.languageDto?.idLanguage === 1) {
          if (translation.shortDescription != this.formComponent.get('shortCastellano')?.value ||
            translation.longDescription != this.formComponent.get('longCastellano')?.value) {
            this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
          }
          translation.shortDescription = this.formComponent.get('shortCastellano')?.value ?? undefined;
          translation.longDescription = this.formComponent.get('longCastellano')?.value ?? undefined;
        } else if (translation.languageDto?.code === "ca" || translation.languageDto?.idLanguage === 2) {
          if (translation.shortDescription != this.formComponent.get('shortCatala')?.value ||
            translation.longDescription != this.formComponent.get('longCatala')?.value) {
            this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
          }
          translation.shortDescription = this.formComponent.get('shortCatala')?.value ?? undefined;
          translation.longDescription = this.formComponent.get('longCatala')?.value ?? undefined;
        } else if (translation.languageDto?.code === "en" || translation.languageDto?.idLanguage === 3) {
          if (translation.shortDescription != this.formComponent.get('shortEnglish')?.value ||
            translation.longDescription != this.formComponent.get('longEnglish')?.value) {
            this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
          }
          translation.shortDescription = this.formComponent.get('shortEnglish')?.value ?? undefined;
          translation.longDescription = this.formComponent.get('longEnglish')?.value ?? undefined;
        }
      });
    }
  }
  // Método para cancelar y reiniciar el formulario
  onCancel(): void {
    this.openCreate = false; // Cambia a modo cerrado
    this.isModify = false; // Quita el modo de modificación
    this.selectedRowId = this.selectedRowDiscountId = this.selectedRowDiscountTypeId = null; // Deselecciona cualquier fila
    this.discountRateModelResponse.discountRateModelCatalogDto = []
    this.formComponent.reset(); // Reinicia el formulario
    this.RateModelDto = new RateModelDto(); // Reinicia la instancia de RateModelDto
    this.cdr.detectChanges(); // Detecta cambios para actualizar la vista
    window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
    console.log('Formulario cerrado y restablecido');
  }

  getListServices(): void {
    this.servicesService.getAllServices().subscribe({
      next: (services: any) => {
        // Aquí puedes asignar la lista de servicios a una propiedad si es necesario
        this.listServices = services.listServiceDto.map((rt: any) => {
          return {
            ...rt,
            serviceTraductionDto: rt.serviceTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
          };
        });
        this.listServices = this.listServices.filter(service => { return service.active == 'S' })
        console.log(this.listServices)
      },
      error: error => {
        console.log('Se ha producido un error al obtener la lista de servicios', error);
      }
    });
  }

  clone() {
    this.taxesService.cloneModel(this.selectedRowId).subscribe({
      next: (response) => {
        this.isCreate = true;
        this.errorMessage = "S'ha clonat correctament1"
        this.onTaxTypeChange(true);
      }
    });
  }

  export() {
    // Construye el parámetro ids: "1" o "1,2,3"
    let ids: string | number | null = null;

    if (this.selectedRowId) {
      ids = this.selectedRowId;
    } else if (this.selectAll) {
      ids = this.modelResponse.listRateModelDto
        .map((m: any) => m.idRateModel)
        .filter((v: any) => v != null)
        .join(',');
    }

    if (!ids) {
      return;
    }

    this.taxesService.exportModel(ids).subscribe({
      next: (res) => {
        const blob = (res as any).body ?? res;
        const cd = (res as any).headers?.get?.('Content-Disposition') || '';
        const m = /filename\*?=(?:UTF-8'')?("?)([^\";]+)\1/i.exec(cd);
        const filename = m ? decodeURIComponent(m[2]) : `export_${new Date().toISOString().slice(0, 10)}.xlsx`;

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = filename;
        document.body.appendChild(a); a.click(); a.remove();
        URL.revokeObjectURL(url);
      },
      error: err => {
        try {
          console.log(err?.error?.text?.());
        } catch { }
        this.isCreate = false;
        this.errorMessage = "Hi ha hagut un error en la descàrrega";
      }
    });
  }

  loadTaxesAcademics() {
    this.academictaxesservice.getListAcademicTaxes(this.modelRequest.pageRequest, this.formComponent.get('codeRateModel')?.value).subscribe({
      next: (response) => {
        if (response != null) {
          this.taxesAcademiques = response.listOwnAcademicFee
        }
      },
      error: (err: any) => {
        console.error('Error al obtener las tasas académicas:', err);
      }
    });
  }

  loadLearningResourcesFees(): void {
    this.learningResourceFeeService.getLearningResourceFeesByRateModel(this.modelRequest.pageRequest,
      this.formComponent.get('codeRateModel')?.value).subscribe({
        next: response => {
          if (response != null) {
            this.learningresource = response.listOwnLearningResourcesRateDto
          }
        },
        error: (err: any) => {
          console.error('Error al obtener las tasas académicas:', err);
        },
      });
  }

  loadOwnAdministrativeFees(): void {
    this.ownadministrativefeeService.getListOwnAdministrativeFee(this.modelRequest.pageRequest, this.formComponent.get('codeRateModel')?.value)
      .subscribe({
        next: response => {
          if (response != null) {
            this.OwnAdministrativeFee = response.listOwnAdministrativeFee;
          }
        }, error: () => {
        }
      });
  }

  selectAllFiles() {
    this.selectedRowId = null
    this.selectAll = !this.selectAll
  }

  deleteDiscountType() {

    this.discountService.deleteDiscountRateModelControlTypeCatalog(this.selectedRowDiscountTypeId).subscribe({
      next: response => {
        this.isCreatedDiscountType = true
        this.isErrorDiscountType = false
        this.errorMessage = "S'ha esborrat correctament"
        this.loadDiscountsRateModelTypes()
        this.isCreateDiscountType = false;
        this.formDiscountTypes.reset()
        this.selectedRowDiscountTypeId = null
      }, error: (error) => {
        this.isCreatedDiscountType = false
        this.isErrorDiscountType = true
        this.errorMessage = error.error.message
      }
    });
  }

  changeControlType() {
    this.formDiscountTypes.get('controlType')?.patchValue(this.listDiscountControlType.filter(list => { return list.idDiscountControlType == this.formDiscountTypes.get('discountControlTypeId')?.value })[0].idDiscountControlType?.toString() || null)
    if (this.formDiscountTypes.get('controlType')?.value == '3') {
      this.formDiscountTypes.get('dateStart')?.patchValue(null)
      this.formDiscountTypes.get('dateEnd')?.patchValue(null)
      this.formDiscountTypes.get('dateStart')?.setErrors(null);
      this.formDiscountTypes.get('dateEnd')?.setErrors(null);
    } else if (this.formDiscountTypes.get('controlType')?.value == '4') {
      this.formDiscountTypes.get('numericValue')?.patchValue(null)
      this.formDiscountTypes.get('numericValue')?.setErrors(null);
    } else {
      this.formDiscountTypes.get('numericValue')?.patchValue(null)
      this.formDiscountTypes.get('dateStart')?.patchValue(null)
      this.formDiscountTypes.get('dateEnd')?.patchValue(null)
      this.formDiscountTypes.get('numericValue')?.setErrors(null);
      this.formDiscountTypes.get('dateStart')?.setErrors(null);
      this.formDiscountTypes.get('dateEnd')?.setErrors(null);
    }
  }

  isDiscountValid(discountCode: any): boolean {
    const discount = this.discountRateModelResponse.discountRateModelCatalogDto.find(disc => disc.generalDiscountCatalogDto?.discountCode === discountCode);
    return discount == undefined;
  }

  //#endregion

}

function sortByDiscountCode(array: any[]) {
  return array.sort((a: { generalDiscountCatalogDto: { discountCode: string; }; }, b: { generalDiscountCatalogDto: { discountCode: any; }; }) =>
    a.generalDiscountCatalogDto.discountCode.localeCompare(b.generalDiscountCatalogDto.discountCode)
  );
}